module.exports = __webpack_public_path__ + "static/media/cons4.5e036259.jpeg";